import { PureComponent } from 'preact-compat'

import { editPublicLabel } from '../services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'

/* eslint-disable import/no-internal-modules */
import { isInputEl } from '../../../../../libs/typeGuards'
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import Icon from '@insided/deprecated-preact-components//assets'

interface Props {
  topicId: number
  contentType: ContentType
  selectedPublicLabel: string | null
  publicLabelText: string
  onPublicLabelInput: (publicLabel: string) => void
  onPublicLabelChanged: (publicLabel: string) => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  phrases?: {
    [key: string]: string
  }
}

class ChangePublicLabel extends PureComponent<Props> {
  async onPublicLabelChanged(newPublicLabel: string) {
    const { contentType, topicId, onPublicLabelChanged, onShowAlert } = this.props
    try {
      await editPublicLabel(contentType, topicId, newPublicLabel)
      onPublicLabelChanged(newPublicLabel)
      onShowAlert('success', 'Public label is changed successfully')
    } catch {
      onShowAlert('error')
    }
  }

  render() {
    const { selectedPublicLabel, publicLabelText, onPublicLabelInput, phrases } = this.props
    const placeholder =
      selectedPublicLabel && selectedPublicLabel !== ''
        ? selectedPublicLabel
        : 'Choose a label or type a custom label'

    let publicLabels = publicLabelText ? [publicLabelText] : []
    if (phrases) {
      publicLabels = publicLabels.concat([
        phrases['topic.public_label.suggestion.blog'],
        phrases['topic.public_label.suggestion.news'],
        phrases['topic.public_label.suggestion.faq'],
        phrases['topic.public_label.suggestion.tutorial'],
        phrases['topic.public_label.suggestion.interview']
      ])
    }

    const publicLabelItems = publicLabels.map((key, idx) => ({
      title: publicLabelText && idx === 0 ? `Add ${key}` : key,
      value: key,
      onClick: async () => await this.onPublicLabelChanged(key),
      variant: 'primary'
    }))

    return (
      <DropdownControl
        align='adjust'
        triggerClass='dropdown-wrapper'
        trigger={
          <InputGroup
            id='product-update-label-selector'
            formGroupClasses='product-update_public-label-selector-wrapper'
            customInput={
              <div className='product-update_public-label-selector'>
                <input
                  type='text'
                  className='form-control product-update_public-label-input'
                  onKeyUp={(e) => {
                    if (isInputEl(e.target)) onPublicLabelInput(e.target.value)
                  }}
                  placeholder={placeholder}
                />
                <span
                  className='product-update_public-label-clear'
                  onClick={async () => await this.onPublicLabelChanged('')}
                  role='button'
                  aria-label='Clear public label'
                >
                  <Icon icon='cancel' width={16} height={16} />
                </span>
              </div>
            }
          />
        }
        items={publicLabelItems}
      />
    )
  }
}

export default ChangePublicLabel
